import { type RentalCalcRequest, type RentalCalcResponse } from '@kgc/rental-core/rental-dto';
import { api } from './client';

/**
 * P0-1 (7-kör, FE-2) — V2-ár-sidebar BE-authoritative pricing kliens (#499 H1-contract).
 *
 * A FE-only `wizard-store.calculateCartPricing` helyett a BE-számítás (pénz-helyesség = P0):
 * `POST /api/v1/rentals/calculate` → `RentalCalcResponse` (a `CartPricing` shape-ekvivalense
 * → drop-in a sidebarba). A BE az authoritative SSoT — a FE-only kalkuláció kerekítés/tier-drift
 * kockázatát zárja. Minden válasz `{ data: ... }` envelope (API-konvenció).
 */
export async function calculateRentalPricing(
  body: RentalCalcRequest
): Promise<{ data: RentalCalcResponse }> {
  return api.post<{ data: RentalCalcResponse }>('/rentals/calculate', body);
}
